import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Modal, Button } from "react-bootstrap";
import Slider from "@mui/material/Slider";

const WIDTH = 1024;
const HEIGHT = 1024;

const CropperDialog = ({ imageSrc, show, onClose, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const getCroppedImage = async () => {
    const createImage = (url) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = (e) => reject(e);
      });

    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = WIDTH;
    canvas.height = HEIGHT;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x * scaleX,
      croppedAreaPixels.y * scaleY,
      croppedAreaPixels.width * scaleX,
      croppedAreaPixels.height * scaleY,
      0,
      0,
      WIDTH,
      HEIGHT
    );

    return new Promise((resolve) => {
        canvas.toBlob(blob => resolve(blob), "image/webp", 0.75);
    });
  };

  const handleUpload = async () => {
    const croppedBlob = await getCroppedImage();
    onCropComplete(croppedBlob);
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Crop Your Photo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {imageSrc && (
          <div style={{ position: "relative", width: "100%", height: 400 }}>
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={1}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={handleCropComplete}
            />
          </div>
        )}
        <div className="mt-3">
          <label htmlFor="zoomSlider">Zoom:</label>
          <Slider
            id="zoomSlider"
            value={zoom}
            min={1}
            max={3}
            step={0.05}
            onChange={(e, val) => setZoom(val)}
            aria-label="Zoom"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleUpload}>
          Crop & Upload
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CropperDialog;
